<!-- 운전현황 헤더 컴포넌트 -->
<template>
    <div block v-b-toggle.opStatus class="accordion-title" style="padding: 3px 10px !important">
        <div class="d-flex">
            <div class="mr-2">
                <span v-if="opStatus">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </span>
                <span v-if="!opStatus">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                </span>
            </div>
            <span>{{ functionModeText }}</span>
        </div>
        <!-- 운전현황 제어버튼 표시 -->
        <div class="d-flex" style="align-items: center">
            <!-- 상세 옵션  -->
            <!-- 비교인자 선택 -->

            <div
                v-if="
                    filterSystemType.sumAvail == 'Y' &&
                    (activeIcon == 'pattern-chart' || activeIcon == 'scatter-chart' || activeIcon == 'stack-chart') &&
                    !isEmpty(rltdTrendData)
                "
                class="d-flex"
                style="align-items: center"
            >
                <span style="width: 9rem">비교 인자 선택</span>

                <select
                    v-if="!isEmpty(rltdTrendData.headers)"
                    class="form-control ml-1 mr-2"
                    v-model="localSelectedRltdPtIdx"
                    id="selectedRltdPtIdx"
                    @change="handleRltdPtIdxChange"
                >
                    <option v-for="related in rltdTrendData.headers" :key="related.ptIdx" :value="related.ptIdx">
                        {{ related.dispText }}
                    </option>
                </select>
            </div>

            <!-- 표시 및 동작 옵션 -->
            <div class="d-flex" style="font-size: 1rem; cursor: pointer">
                <transition name="fade-slide">
                    <span
                        v-if="showChartSaveButton"
                        class="saveChartOrder"
                        @click="$emit('set-chart-order', $event)"
                        v-b-tooltip.hover
                    >
                        <div>순서 저장</div>
                    </span>
                </transition>
                <span
                    v-show="
                        filterSystemType.sumAvail == 'N' &&
                        currentNode.nodeType == 'Group' &&
                        activeIcon === 'prop-chart'
                    "
                    class="status-icon"
                    @click="$emit('open-table-view-select', $event)"
                    v-b-tooltip.hover
                    :title="$t('표시 속성 선택')"
                >
                    <i class="fas fa-filter" aria-hidden="true"></i>
                </span>
                <span
                    v-if="activeIcon === 'equip-chart' || activeIcon === 'prop-chart'"
                    class="status-icon"
                    :class="{ active: isRltdPoint }"
                    @click="$emit('show-rltd-point-trend', $event, false)"
                    v-b-tooltip.hover
                    :title="$t('영향 인자 표시')"
                >
                    <i class="fas fa-link" aria-hidden="true"></i>
                </span>
                <span
                    v-if="activeIcon === 'equip-chart' || activeIcon === 'prop-chart'"
                    class="status-icon"
                    :class="{ active: dragMode }"
                    @click="$emit('toggle-drag-mode', $event)"
                    v-b-tooltip.hover
                    :title="dragMode ? '드래그 모드 끄기' : '드래그 모드 켜기'"
                >
                    <i class="fas fa-arrows-alt" aria-hidden="true"></i>
                </span>
                <b-dropdown
                    v-if="activeIcon === 'equip-chart' || activeIcon === 'prop-chart'"
                    variant="link"
                    toggle-class="text-decoration-none p-0"
                    no-caret
                >
                    <template #button-content>
                        <span
                            class="status-icon"
                            style="font-size: 1rem !important"
                            v-b-tooltip.hover
                            :title="$t('차트 표시수')"
                        >
                            <i class="fas fa-caret-down" aria-hidden="true"></i>
                        </span>
                    </template>
                    <b-dropdown-item @click="$emit('set-chart-view', '1', $event)">1</b-dropdown-item>
                    <b-dropdown-item @click="$emit('set-chart-view', '2', $event)">2</b-dropdown-item>
                    <b-dropdown-item @click="$emit('set-chart-view', '3', $event)">3</b-dropdown-item>
                </b-dropdown>
                <button
                    v-if="activeIcon == 'org-chart' && filterSystemType.sumAvail == 'Y'"
                    class="status-icon"
                    :class="{ active: isIgnoreZero }"
                    @click="$emit('change-ignore-zero', $event)"
                    v-b-tooltip.hover
                    :title="$t(isIgnoreZero ? '빈값 표시' : '빈값 제외')"
                >
                    <i class="fas fa-eye-slash" aria-hidden="true"></i>
                </button>
                <b-dropdown
                    v-if="activeIcon == 'org-chart' && filterSystemType.sumAvail == 'Y'"
                    variant="link"
                    toggle-class="text-decoration-none p-0"
                    no-caret
                >
                    <template #button-content>
                        <span
                            class="status-icon"
                            style="font-size: 1rem !important"
                            v-b-tooltip.hover
                            :title="$t('단위 표시 방법')"
                        >
                            <i class="fas fa-caret-down" aria-hidden="true"></i>
                        </span>
                    </template>
                    <b-dropdown-item @click="$emit('set-org-data', 'percent', $event)">백분율</b-dropdown-item>
                    <b-dropdown-item @click="$emit('set-org-data', 'format', $event)">환산값</b-dropdown-item>
                    <b-dropdown-item @click="$emit('set-org-data', 'origin', $event)">원본값</b-dropdown-item>
                </b-dropdown>

                <!-- 기능 모드 -->
                <button
                    class="status-icon"
                    :class="{ active: activeIcon === 'tableView' }"
                    @click="$emit('icon-click', 'tableView', $event)"
                    v-b-tooltip.hover
                    :title="$t('일반 현황')"
                >
                    <i class="fas fa-list-ul" aria-hidden="true"></i>
                </button>

                <button
                    v-show="filterSystemType.sumAvail == 'Y'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'org-chart' }"
                    @click="$emit('icon-click', 'org-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t('구성 분석')"
                >
                    <i class="fas fa-th" aria-hidden="true"></i>
                </button>
                <button
                    v-show="filterSystemType.sumAvail == 'Y'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'flow-chart' }"
                    @click="$emit('icon-click', 'flow-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t('흐름 분석')"
                >
                    <i class="fas fa-random" aria-hidden="true"></i>
                </button>
                <button
                    v-show="filterSystemType.sumAvail == 'Y' && queryType == 'MONTH'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'pattern-chart' }"
                    @click="$emit('icon-click', 'pattern-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t(`패턴 분석`)"
                >
                    <i class="fas fa-braille" aria-hidden="true"></i>
                </button>

                <button
                    v-show="filterSystemType.sumAvail == 'Y'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'scatter-chart' }"
                    @click="$emit('icon-click', 'scatter-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t(`상관 분석`)"
                >
                    <i class="fas fa-chart-line"></i>
                </button>
                <button
                    v-show="filterSystemType.sumAvail == 'Y'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'stack-chart' }"
                    @click="$emit('icon-click', 'stack-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t(`성분 분석`)"
                >
                    <i class="fas fa-layer-group"></i>
                </button>

                <button
                    v-show="currentNode.nodeType == 'Group' && filterSystemType.sumAvail == 'N'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'tileView' }"
                    @click="$emit('icon-click', 'tileView', $event)"
                    v-b-tooltip.hover
                    :title="$t('타일형')"
                >
                    <i class="fas fa-th" aria-hidden="true"></i>
                </button>
                <button
                    class="status-icon"
                    :class="{ active: activeIcon === 'equip-chart' }"
                    @click="$emit('icon-click', 'equip-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t(`${currentNode.nodeType !== 'Equip' ? '트랜드1형' : '트랜드'}`)"
                >
                    <i class="fas fa-chart-area" aria-hidden="true"></i>
                </button>
                <button
                    v-show="currentNode.nodeType == 'Group' && filterSystemType.sumAvail == 'N'"
                    class="status-icon"
                    :class="{ active: activeIcon === 'prop-chart' }"
                    @click="$emit('icon-click', 'prop-chart', $event)"
                    v-b-tooltip.hover
                    :title="$t('트랜드2형')"
                >
                    <i class="fas fa-chart-area" aria-hidden="true"></i>
                </button>
                <button
                    class="status-icon"
                    :class="{ active: activeIcon === 'data-base' }"
                    @click="$emit('handle-database-modal', true)"
                    v-b-tooltip.hover
                    :title="$t('데이터보기')"
                >
                    <i class="fas fa-database" aria-hidden="true"></i>
                </button>
                <div v-if="currentNode.nodeType == 'Group' && filterSystemType.sumAvail == 'N'" class="d-flex">
                    <button
                        class="control-icon"
                        @click="$emit('handle-ctrl-modal', 'Group', $event)"
                        v-b-tooltip.hover
                        :disabled="!ctrlMode"
                        :style="{ backgroundColor: !ctrlMode ? '#eab897' : '' }"
                        :title="$t('그룹 제어')"
                    >
                        <i class="fas fa-sitemap" aria-hidden="true"></i>
                    </button>
                    <button
                        class="control-icon"
                        @click="$emit('handle-ctrl-modal', 'Select', $event)"
                        v-b-tooltip.hover
                        :disabled="!ctrlMode"
                        :style="{ backgroundColor: !ctrlMode ? '#eab897' : '' }"
                        :title="$t('멀티 제어')"
                    >
                        <i class="fas fa-tasks" aria-hidden="true"></i>
                    </button>
                </div>
                <div v-show="currentNode.nodeType == 'Equip' && filterSystemType.sumAvail == 'N'" v-else>
                    <button
                        class="unit-control-icon"
                        @click="$emit('unit-equip-control', $event)"
                        :disabled="!ctrlMode"
                        :style="{ backgroundColor: !ctrlMode ? '#e38e8e' : '' }"
                    >
                        {{ "제어 실행" }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getFunctionModeText } from "../constants/functionModes";

export default {
    name: "OperationStatusHeader",
    props: {
        opStatus: {
            type: Boolean,
            default: false,
        },
        functionMode: {
            type: String,
            default: "",
        },
        activeIcon: {
            type: String,
            required: true,
        },
        filterSystemType: {
            type: Object,
            required: true,
        },
        currentNode: {
            type: Object,
            required: true,
        },
        rltdTrendData: {
            type: Object,
            default: null,
        },
        selectedRltdPtIdx: {
            type: [Number, String],
            default: null,
        },
        showChartSaveButton: {
            type: Boolean,
            default: false,
        },
        isRltdPoint: {
            type: Boolean,
            default: false,
        },
        dragMode: {
            type: Boolean,
            default: false,
        },
        isIgnoreZero: {
            type: Boolean,
            default: true,
        },
        ctrlMode: {
            type: Boolean,
            default: false,
        },
        queryType: {
            type: String,
            default: "NOW",
        },
    },
    emits: [
        "set-chart-order",
        "open-table-view-select",
        "show-rltd-point-trend",
        "toggle-drag-mode",
        "set-chart-view",
        "change-ignore-zero",
        "set-org-data",
        "icon-click",
        "handle-database-modal",
        "handle-ctrl-modal",
        "unit-equip-control",
        "selected-rltd-pt-idx-change",
    ],
    data() {
        return {
            localSelectedRltdPtIdx:
                typeof this.selectedRltdPtIdx === "string" ? Number(this.selectedRltdPtIdx) : this.selectedRltdPtIdx,
        };
    },
    computed: {
        functionModeText() {
            return this.functionMode || getFunctionModeText(this.activeIcon);
        },
    },
    watch: {
        selectedRltdPtIdx(newVal) {
            // prop이 문자열로 들어올 수 있으므로 Number로 변환
            this.localSelectedRltdPtIdx = typeof newVal === "string" ? Number(newVal) : newVal;
        },
    },
    methods: {
        handleRltdPtIdxChange() {
            // select의 value가 문자열로 처리되므로 Number로 변환
            const value =
                typeof this.localSelectedRltdPtIdx === "string"
                    ? Number(this.localSelectedRltdPtIdx)
                    : this.localSelectedRltdPtIdx;
            this.$emit("selected-rltd-pt-idx-change", value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/common/_detail-buttons.scss";

.table-view-container {
    padding: 1rem;
    border-radius: 10px;
    border: solid #eee 1px;
}
</style>
